import PositionsScrollableList from 'components/Lists/ListView/PositionsScrollableList';
import RestaurantsScrollableList from 'components/Lists/ListView/RestaurantsScrollableList';
import Text from 'components/Text/Text';
import React from 'react';
import { RequestEntity, IItemCategory } from 'types';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import SubcategoriesScrollView from './components/SubcategoriesScrollView';
import classNames from 'classnames';
import style from './Info.module.scss';

interface IItem {
	isOpenInfo: boolean;
	data: IItemCategory;
	categoryTypeName: Nullable<string>;
}

const Info: React.FC<IItem> = ({ isOpenInfo, data, categoryTypeName }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isOpenInfo });

	return (
		<div className={containerClasses} data-test="Info">
			<div className={style.wrapper}>
				<div className={style.imgWrapper}>
					<ImgUploaderByEntityId
						resource={RequestEntity.Categories}
						entityID={data.filePath ? data.id : ''}
						photoSize="Small"
						isMakeImageRequest={isOpenInfo}
						loaderSize="small"
					/>
				</div>
				<div className={style.infoContainer}>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="categoryLabel"
							theme="neutralLight"
						/>
						<Text className={style.blockValue} translationKey={data.name} withTooltip={true} />
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="categoryTypeLabel"
							theme="neutralLight"
						/>
						<Text
							className={style.blockValue}
							translationNameSpace="listing"
							translationKey={categoryTypeName}
							withTooltip={true}
						/>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="customerLabel"
							theme="neutralLight"
						/>
						<Text className={style.blockValue} translationKey={data.customerName} withTooltip={true} />
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="positionLabel"
							theme="neutralLight"
						/>
						<div className={style.blockValue}>
							<PositionsScrollableList restaurants={data.restaurantsCategories} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="restaurantsLabel"
							theme="neutralLight"
						/>
						<div className={style.blockValue}>
							<RestaurantsScrollableList restaurants={data.restaurantsCategories} />
						</div>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="subcategoriesLabel"
							theme="neutralLight"
						/>
						<div className={style.blockValue}>
							<SubcategoriesScrollView data={data.subCategories} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(Info);
